module.exports = __webpack_public_path__ + "static/media/banner_lcdlm2_small@3x.a4c765db.jpg";